export default __webpack_public_path__ + "static/media/a7198c5482b8b41d67188f5ee4d7fed11581602128839.6bc33cf6.webp";